var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"border":"left","text":"","type":_vm.type,"icon":"mdi-alert-circle","transition":"scale-transition"}},[_c('h4',{staticClass:"grow"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }